// @flow
import FontAwesome from 'react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import authentication from '../../services/api';
import style from './style';

import locale from '../../locales/index';

import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Logo from './components/Logo/Logo';

const Login = () => (<div>
  <Header />
  <Logo />
  <div style={style.buttonStyle}>
    <Button onClick={() => { authentication.login(); }} bsStyle="default" bsSize="large">
      <FontAwesome name="google-plus" />&nbsp;
      {locale.loginButton}
    </Button>
  </div>
  <Footer />
</div>);

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/Login.js